import React from 'react';
import { Modal, Form, Select, Input } from 'antd';
import AxiosOICStat from 'AxiosOICStat';
import { message } from 'antd';

const { Option } = Select;

const EditCountryMappingModal = ({visible, onCancel, onUpdate, editingRecord, editForm, loading, countryOptions}) => {
  const handleEditSubmit = async (values) => {
    try {
      await AxiosOICStat.put('/external_api/sdg/country-mappings', {
        geo_area_code: editingRecord.geo_area_code,
        ...values
      });
      message.success('Country mapping updated successfully');
      onUpdate(values);
      onCancel();
    } catch (err) {
      const detail =
        err?.response?.data?.detail ||
        err?.message ||
        'Failed to update country mapping. Please try again.';
      message.error(detail);
    }
  };

  return (
    <Modal
      title="Edit Country Mapping"
      open={visible}
      onOk={() => editForm.submit()}
      onCancel={onCancel}
      okText="Save Changes"
      cancelText="Cancel"
      confirmLoading={loading}
    >
      <Form
        form={editForm}
        layout="vertical"
        onFinish={handleEditSubmit}
      >
        <Form.Item
          name="geo_area_code"
          label="SDG Geo Area Code"
        >
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="geo_area_name"
          label="Geo Area Name"
          rules={[{ required: true, message: 'Please enter geo area name' }]}
        >
          <Input placeholder="e.g., Türkiye" />
        </Form.Item>

        <Form.Item
          name="c_code"
          label="OICStat Country Code"
          rules={[{ required: true, message: 'Please select country code' }]}
        >
          <Select
            showSearch
            placeholder="Select Country"
            options={countryOptions}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>

        <Form.Item
          name="is_private"
          label="Private"
        >
          <Select>
            <Option value={0}>No</Option>
            <Option value={1}>Yes</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditCountryMappingModal;